// Port of api/fuel/app/classes/filter/package/games/play/package/play.php
export default {
	require: function(config, filter) { return !filter.play || !filter.play.group },
	run: function(pkg, local) {
		var play = local.result || {}
		pkg.play = {
			id: parseInt(play.play_id || 0, 10),
			date: parseInt(play.play_date || 0, 10),
			length: parseInt(play.play_length || 0, 10),
			location: play.play_location || '',
			count: parseInt(play.play_count || 0, 10),
			user: parseInt(play.user_id || 0, 10),
			game: parseInt(play.game_id || 0, 10),
			comment: String(play.play_comment || '').replace(/\n/g, '<br />'),
			incomplete: parseInt(play.play_incomplete || 0, 10),
			expansion: parseInt(play.play_expansion || 0, 10),
			result: parseInt(play.play_result || 0, 10),
			won: parseInt(play.play_won || 0, 10)
		}
		return pkg
	}
}
